define('commons/template-chooser',['templates/base-station-templates', 'templates/device-templates', 'templates/deleted-device-templates', 'templates/site-templates', 'templates/device-type-templates', 'templates/contract-templates', 'templates/contractinfo-templates', 'templates/invoice-templates', 'templates/device-message-error-templates', 'templates/simulationTemplates'],
        function( baseStationTemplates, deviceTemplates, deletedDeviceTemplates, siteTemplates, deviceTypeTemplates, contractTemplates, contractInfoTemplates, invoiceTemplates, deviceMessageErrorTemplates, simulationTemplates) {
    
    var TemplateChooser = function(beanName, selectedFields, extra){
        this.beanName = beanName;
        this.selectedFields = selectedFields;
        this.extra = extra || {};
    };
    
    /**
     * Headers templates
     */
    TemplateChooser.prototype.buildHeaders = function( withSelector ){
        switch (this.beanName) {
            case 'BaseStation':
                return this._getHeaders(baseStationTemplates, withSelector);
            case 'Device':
                return this._getHeaders(deviceTemplates, withSelector);
            case 'DeletedDevice':
                return this._getHeaders(deletedDeviceTemplates, withSelector);
            case 'Site':
                return this._getHeaders(siteTemplates, withSelector);
            case 'DeviceType':
                return this._getHeaders(deviceTypeTemplates, withSelector);
            case 'Contract':
                return this._getHeaders(contractTemplates, withSelector);
            case 'ContractBean':
                return this._getHeaders(contractTemplates, withSelector);
            case 'ContractInfo':
                return this._getHeaders(contractInfoTemplates, withSelector);
            case 'Invoice' :
                return this._getHeaders(invoiceTemplates, withSelector);
            case 'InvoiceBean' :
                return this._getHeaders(invoiceTemplates, withSelector);
            case 'DeviceMessageError' :
                return this._getHeaders(deviceMessageErrorTemplates, withSelector);
            case 'Simulation' :
                return this._getHeaders(simulationTemplates, withSelector);
            default:
                throw 'Given bean name is unknown : ' + this.beanName;
        }
    };
    
    /**
     * Data templates
     */
    TemplateChooser.prototype.buildDataTemplates = function( withSelector ){
        switch (this.beanName) {
            case 'BaseStation':
                return this._getDataTemplates(baseStationTemplates, withSelector);
            case 'Device':
                return this._getDataTemplates(deviceTemplates, withSelector);
            case 'DeletedDevice':
                return this._getDataTemplates(deletedDeviceTemplates, withSelector);
            case 'Site':
                return this._getDataTemplates(siteTemplates, withSelector);
            case 'DeviceType':
                return this._getDataTemplates(deviceTypeTemplates, withSelector);
            case 'Contract':
                return this._getDataTemplates(contractTemplates, withSelector);
            case 'ContractBean':
                return this._getDataTemplates(contractTemplates, withSelector);
            case 'ContractInfo':
                return this._getDataTemplates(contractInfoTemplates, withSelector);
            case 'Invoice' :
                return this._getDataTemplates(invoiceTemplates, withSelector);
            case 'InvoiceBean' :
                return this._getDataTemplates(invoiceTemplates, withSelector);
            case 'DeviceMessageError' :
                return this._getDataTemplates(deviceMessageErrorTemplates, withSelector);
            case 'Simulation' :
                return this._getDataTemplates(simulationTemplates, withSelector);
            default:
                throw 'Given bean name is unknown : ' + this.beanName;
        }
    };

    TemplateChooser.prototype._getHeaders = function(templates, withSelector){
    	var templatesConf = typeof templates === "function" ? templates(this.extra) : templates;
        var result = [];
        if(withSelector){
            result[0] = {
                    'nodeType' : 'th',
                    'content' : {
                        'nodeType' : 'input',
                        'id' : 'selectAllOnPage',
                        'classes' : ['selectCheckbox'],
                        'attributes' : {'type' : 'checkbox'}
                    }
            }
        }
        
        for(var i = 0, length = this.selectedFields.length ; i < length; i++){
            var field = this.selectedFields[i];
            if(!field){
                throw 'Field [' + field + '] not found for bean [' + this.beanName + ']';
            } else{
                var metadata = templatesConf.headers[field];
                if (metadata) {
                    result.push(metadata);
                }
            }
        }
        
        return result;
    };
    
    TemplateChooser.prototype._getDataTemplates = function(templates, withSelector){
    	var templatesConf = typeof templates === "function" ? templates(this.extra) : templates;
        var result = [];
        if(withSelector){
            result[0] = {
                    "nodeType" : "td",
                    "attributes" : {"align" : "center"},
                    "content" : {
                        "nodeType" : "input",
                        "classes" : ["selectCheckbox"],
                        "id" : "${id}",
                        "data" : {"id" : "${id}"},
                        "attributes" : {"type" : "checkbox"},
                        "value" : "${id}"
                    }
            };
        }
        for(var i = 0, length = this.selectedFields.length ; i < length; i++){
            var field = this.selectedFields[i];
            if(!field){
                throw 'Field [' + field + '] not found for bean [' + this.beanName + ']';
            } else{
                var metadata = templatesConf.templates[field];
                if (metadata) {
                    result.push(metadata);
                }
            }
        }
        
        return result;
    };
    
    return TemplateChooser;
});

